import { NovaPluginIds } from "panels/controls/PluginAccessPanel/constants"
import { GenericTryPluginModal } from "./GenericTryPluginModal"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { selectUserID, selectUserLicense } from "user/profile/selectors"
import { useCallback } from "react"
import { useAsyncCallback } from "@nova/use-async-callback"
import { ButtonStatus } from "@nova/component-btn"
import { createLiveVideoFlight } from "features/pubsub/entityActions/flights/liveVideo"
import { setGlobalNotificationContext } from "user/profile/slice"
import { GlobalNotificationStatus } from "@nova/component-global-notification"
import { hideGlobalModal } from "runlevel/actions"

/** @deprecated not being offered anymore since conversion rate was bad */
export const TryLiveVideoModal = () => {
    const dispatch = useAppDispatch()
    const license = useAppSelector(selectUserLicense)
    const userId = useAppSelector(selectUserID)

    const { requestLiveVideoTrial, loading: trialIsBeingRequested } = useAsyncCallback(
        {
            requestLiveVideoTrial: async () => {
                if (!userId || !license) return

                try {
                    const response = await fetch(
                        `/api/license/${license.licenseId}?ownerId=${encodeURIComponent(license.ownerId)}`,
                        {
                            method: "PATCH",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                requestLiveVideoTrialConsumption: true,
                            }),
                        }
                    )

                    const json = await response.json()

                    if (response.ok) {
                        dispatch(
                            createLiveVideoFlight({
                                data: { createdBy: { userId }, name: "", saveRecording: true },
                            })
                        )
                        dispatch(hideGlobalModal())
                    } else {
                        dispatch(
                            setGlobalNotificationContext({
                                message: json.error || "Failed to begin Live Video trial period.",
                                timeoutInMs: 4000,
                                status: GlobalNotificationStatus.error,
                            })
                        )
                    }
                } catch (error) {
                    console.error(error)
                }
            },
        },
        [userId]
    )

    const tryLiveVideo = useCallback(() => {
        if (!license) return
        if (!license.liveVideoTrialExpiration) requestLiveVideoTrial()
        else if (new Date() < new Date(license.liveVideoTrialExpiration)) {
            if (userId)
                dispatch(
                    createLiveVideoFlight({
                        data: { createdBy: { userId }, name: "", saveRecording: true },
                    })
                )
        } else {
            dispatch(
                setGlobalNotificationContext({
                    message: "Live Video trial period has expired.",
                    timeoutInMs: 4000,
                    status: GlobalNotificationStatus.error,
                })
            )
        }
    }, [dispatch, requestLiveVideoTrial, license, userId])

    return (
        <GenericTryPluginModal
            pluginId={NovaPluginIds.LiveVideo}
            title="Try Livestream for 24 hours"
            subtitle="Connect. Stream. Share."
            body="Real-time situational awareness to everyone through a secure link. Empower decision-makers to act and make better-informed decisions with confidence."
            footer="Use Livestream for 24 hours."
            buttonTitle="Try for free"
            onButtonClick={tryLiveVideo}
            primaryButtonProps={{
                status: trialIsBeingRequested ? ButtonStatus.Loading : undefined,
            }}
        />
    )
}
